export { default as GDMBox } from './GDMBox';

export type { GDMBoxComponent, GDMBoxProps } from './GDMBox.type';
